// see: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font#options
const DEFAULT_CANVAS_FONT_SIZE_PX = 10;

const CODELOGIC_BASE_FONT_SIZE = DEFAULT_CANVAS_FONT_SIZE_PX * 1.2;

export const em = (emValue: number) =>
  (emValue * CODELOGIC_BASE_FONT_SIZE).toFixed(6);

